import { Redacted, Schema } from "effect";
import { privateDependencyFailure } from "@workerstation/shared/errors/private-cause";

export const ModalFocusOpen = Schema.Boolean;
export class ModalFocusFailure extends privateDependencyFailure<ModalFocusFailure>()("ModalFocusFailure", "modal-focus") {}
export const modalFocusFailure = (cause: unknown) => new ModalFocusFailure({ cause: Redacted.make(cause) });
export interface ModalFocusCallbacks {
  readonly isOpen: () => boolean;
  readonly remember: (target: HTMLElement) => void;
  readonly previous: () => HTMLElement | null;
  readonly close: () => void;
}
